module.exports = __webpack_public_path__ + "img/illustrator.21d4729a.svg";